var map = {
	"./ic_add-image.svg": "91ec",
	"./ic_add-table.svg": "3377",
	"./ic_add.svg": "a524",
	"./ic_add_black.svg": "0d22",
	"./ic_add_red.svg": "2e02",
	"./ic_add_second.svg": "720f",
	"./ic_add_white.svg": "aaee",
	"./ic_align-center.svg": "44cd",
	"./ic_align-left.svg": "707d",
	"./ic_align-right.svg": "0661",
	"./ic_alphabet-list.svg": "9edf",
	"./ic_arrow_down.svg": "0e5c",
	"./ic_arrow_down_black.svg": "6f94",
	"./ic_arrow_down_gray.svg": "a4b3",
	"./ic_arrow_left_red.svg": "fbc3",
	"./ic_arrow_right.svg": "4aca",
	"./ic_arrow_right_red.svg": "79f4",
	"./ic_arrow_up.svg": "788f",
	"./ic_arrow_with_tail.svg": "dbe8",
	"./ic_bin.svg": "4e0c",
	"./ic_bold.svg": "a3f5",
	"./ic_bottom_arrow.svg": "ba63",
	"./ic_bullet-list.svg": "7b29",
	"./ic_camera.svg": "a4e4",
	"./ic_chevron_down.svg": "08f7",
	"./ic_chevron_filter.svg": "1296",
	"./ic_chevron_solid.svg": "1e87",
	"./ic_clock.svg": "2f8a",
	"./ic_close.svg": "febb",
	"./ic_collab.svg": "a208",
	"./ic_cross.svg": "a46a",
	"./ic_curve_arrow.svg": "7f73",
	"./ic_customize.svg": "6e60",
	"./ic_devices.svg": "30fd",
	"./ic_dustbin.svg": "4fcc",
	"./ic_dustbin_v2.svg": "4aba",
	"./ic_empty-line.svg": "d5f9",
	"./ic_eye.svg": "0892",
	"./ic_facebook.svg": "38a0",
	"./ic_facebook_bg_black.svg": "68e2",
	"./ic_facebook_red.svg": "45d7",
	"./ic_factory.svg": "1835",
	"./ic_filter.svg": "e3c5",
	"./ic_filter_2.svg": "6f87",
	"./ic_folder.svg": "dfa3",
	"./ic_in-question-list.svg": "daba",
	"./ic_infinity.svg": "0b51",
	"./ic_infinity_v2.svg": "c37c",
	"./ic_instagram.svg": "a97a",
	"./ic_instagram_red.svg": "4593",
	"./ic_italic.svg": "abdc",
	"./ic_latihan.svg": "f92b",
	"./ic_left_arrow.svg": "5f9a",
	"./ic_link_bg_black.svg": "41e4",
	"./ic_linkedin_bg_black.svg": "7a96",
	"./ic_lock.svg": "ddf1",
	"./ic_logo_main.svg": "8602",
	"./ic_magic.svg": "977c",
	"./ic_magic_wand.svg": "2857",
	"./ic_new-bin.svg": "60d8",
	"./ic_new.svg": "1d88",
	"./ic_notes.svg": "dbe5",
	"./ic_number-list.svg": "0881",
	"./ic_paper_stack.svg": "3d04",
	"./ic_pdf.svg": "2609",
	"./ic_pdf_v2.svg": "47e3",
	"./ic_pencil.svg": "b0bb",
	"./ic_pencil_edit.svg": "8af3",
	"./ic_plus_sign.svg": "fff4",
	"./ic_plus_sign_gray.svg": "d127",
	"./ic_plus_sign_white.svg": "22be",
	"./ic_plus_with_box.svg": "30b3",
	"./ic_previous.svg": "6435",
	"./ic_profile.svg": "0eb9",
	"./ic_rearrange_arrow.svg": "ae54",
	"./ic_redo.svg": "6e1f",
	"./ic_roman-list.svg": "6c30",
	"./ic_search.svg": "84db",
	"./ic_search_filter.svg": "9e28",
	"./ic_signup_question.svg": "0cac",
	"./ic_telegram_gray.svg": "60b2",
	"./ic_telegram_red.svg": "c41c",
	"./ic_tick.svg": "e516",
	"./ic_tiktok_gray.svg": "93a7",
	"./ic_tiktok_red.svg": "b9f5",
	"./ic_tuition.svg": "8513",
	"./ic_twitter.svg": "6e6c",
	"./ic_twitter_bg_black.svg": "ec4d",
	"./ic_twitter_red.svg": "9dad",
	"./ic_undo.svg": "23b9",
	"./ic_up_down.svg": "9aff",
	"./ic_up_down_disable.svg": "db6f",
	"./ic_upload_red.svg": "fbeb",
	"./ic_video.svg": "564f",
	"./ic_whatsapp.svg": "c9b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";